import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseEventAwayStatusChanged } from 'entities/Users/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventUserAwayStatusChanged = () => {
  const { usersStore, websocket } = useEntitiesContext()
  const handle = (data: IResponseEventAwayStatusChanged) => {
    const user = usersStore.getItem(data.id)
    if (user) user.setAwayStatus(data.isAway)
  }

  useEffect(() => websocket.on(WebsocketEvent.UserAwayStatusChanged, handle), [])
}
